import {
  Fraction,
  makeEmptyFraction,
} from 'src/models/helperTypes/FractionationType';
import { creditCard } from 'src/constants/paymentTypes';
import { GridSize } from '@material-ui/core';
import profiles from 'src/constants/profileTypes';

export const filterFractionsByPaymentType = (
  fractionations: Fraction[],
  paymentType: string,
  profileType?: string,
): Fraction[] => {
  if (paymentType === creditCard) {
    if (profileType === profiles.RETENCION) {
      return fractionations.filter(
        (f) =>
          f.paymentType === creditCard &&
          (f.installmentNumber === 1 || f.installmentNumber === 12),
      );
    }
    return fractionations.filter((f) => f.paymentType === creditCard);
  }

  return fractionations.filter((f) => f.paymentType !== creditCard);
};

export const findFractionByQuantity = (
  fractionations: Fraction[],
  paymentQuantity: number,
  paymentType: string,
  profileType?: string,
): Fraction => {
  const usedFractions = filterFractionsByPaymentType(
    fractionations,
    paymentType,
    profileType,
  );
  const fraction = usedFractions.find(
    (frac) => frac.installmentNumber === paymentQuantity,
  );
  return fraction || makeEmptyFraction();
};

export const getFractionsGridSize = (
  paymentType: string,
  profileType?: string,
): GridSize => {
  if (profileType === profiles.RETENCION) {
    return paymentType === creditCard ? 6 : 3;
  }
  return paymentType === creditCard ? 3 : 6;
};
